
<div *ngIf="person; else loading" class="person k-hbox" [attr.title]="getDisplayTitle(person)">
  <div *ngIf="showImage" class="image">
    <kendo-avatar *ngIf="!person.imageSrc" shape="circle" [initials]="getInitials(person)"></kendo-avatar>
    <kendo-avatar *ngIf="person.imageSrc" shape="circle" [imageSrc]="person.imageSrc"></kendo-avatar>
  </div>
  <div *ngIf="showName" class="details" [style.fontSize] = "">
    <h5 [style.fontSize.px]="fontSize">{{person.displayName}} <span *ngIf="person.isAadGuest">{{'aad_guest'|i18n}}</span></h5>
    <span *ngIf="showLogin">{{person.email || person.login}}</span>
  </div>
</div>

<ng-template #loading>
  <!-- NTH Circ Loader testen mit Wrapping - und wrapper div in loader integrieren -->
  <circ-loader [size]="'inherit'"></circ-loader>
</ng-template>
